<template>
  <!-- Microsoft, Google or password sign-in as three cards (US 9365) -->
  <div class="us-signin" role="radiogroup" :aria-label="$t('users_page.sign_in.label')">
    <button v-for="method in methods"
            :key="method"
            type="button"
            role="radio"
            class="us-signin__option"
            :class="{ 'is-on': current === method }"
            :aria-checked="current === method ? 'true' : 'false'"
            :disabled="disabled"
            :qid="'sign-in-' + method"
            @click="$emit('input', method)"
    >
      <SignInMethodIcon :method="method"/>
      {{ $t('users_page.sign_in.' + method) }}
    </button>
  </div>
</template>

<script>
  import SignInMethodIcon from '@/components/user/SignInMethodIcon.vue';

  export default {
    name: 'SignInMethodPicker',
    components: {
      SignInMethodIcon
    },
    props: {
      value: String,
      disabled: Boolean
    },
    data() {
      return {
        methods: ['Microsoft', 'Google', 'Application']
      }
    },
    computed: {
      // Users without a method sign in with a password
      current() {
        return this.value || 'Application';
      }
    }
  }
</script>
